// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1egz1","title":"BackImages_title__UPWC1","images":"BackImages_images__2yU3n"};